<template>
    <form>
        <h4 class="card-title">{{ $t('medium_grant.logical__1_subtitle') }}</h4>
        <div class="row">
            <div class="col-lg-4">
                <!-- Title of the project -->
                <div class="form-group">
                    <textarea
                        class="form-control"
                        name="logical.projectTitle"
                        disabled
                        v-model="MonitoringForm.title"
                        :error="getError('logical.projectTitle')"
                        v-validate="'required'"
                        :data-vv-as="$t('medium_grant.logical__1_project_title')"
                        :label="$t('medium_grant.logical__1_project_title')"
                        :placeholder="$t('medium_grant.logical__1_project_title')"
                        >
                    </textarea>
                </div>

                <!-- Organisation -->
                <div class="form-group">
                    <textarea
                        class="form-control"
                        name="original_logframe.organisation"
                        v-model="MonitoringForm.model.original_logframe.organisation"
                        :error="getError('original_logframe.organisation')"
                        v-validate="'required'"
                        :data-vv-as="$t('medium_grant.logical__1_organisation')"
                        :label="$t('medium_grant.logical__1_organisation')"
                        :placeholder="$t('medium_grant.logical__1_organisation')"
                        >
                    </textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div>
                    <h4 class="card-title pb-0 mb-0 mt-4"><strong>{{ $t('medium_grant.logical__1_priority_action') }}</strong></h4>
                    <p class="mt-2" v-if="MonitoringForm.model.original_logframe.enhace_management">
                        {{$t('medium_grant.technical__1_enhace_management')}}
                    </p>
                    <p class="mt-2" v-if="MonitoringForm.model.original_logframe.enforce_legal">
                        {{$t('medium_grant.technical__1_enforce_legal')}}
                    </p>
                    <p class="mt-2" v-if="MonitoringForm.model.original_logframe.support_local">
                        {{$t('medium_grant.technical__1_support_local')}}
                    </p>
                </div>

                <table class="mt-5 table-bordered" style="table-layout: fixed" width="100%">
                    <thead class="text-center">
                        <th class="align-baseline" width="16%">
                            {{$t('medium_grant.logical__1_results')}} <br/> {{$t('medium_grant.logical__1_results_direct_tangible')}}
                            <br/> <span class="font-italic font-weight-normal">{{$t('medium_grant.logical__1_ecpcm_guidelines')}}</span>
                            <br/> <a class="text-body" href="https://ec.europa.eu/europeaid/sites/devco/files/methodology-aid-delivery-methods-project-cycle-management-200403_en_2.pdf" target="_blank">https://ec.europa.eu/europeaid/sites/devco/files/methodology-aid-delivery-methods-project-cycle-management-200403_en_2.pdf</a>
                        </th>
                        <th class="align-baseline" width="21%">
                            {{$t('medium_grant.logical__1_indicator')}} <br/>
                            <span class="font-italic font-weight-normal">{{$t('medium_grant.logical__1_indicator_evidence')}}</span>
                        </th>
                        <th class="align-baseline" width="21%">
                            {{$t('medium_grant.logical__1_baseline')}} <br/>
                            <span class="font-weight-normal">{{$t('medium_grant.logical__1_reference_year')}}</span>
                        </th>
                        <th class="align-baseline" width="21%">
                            {{$t('medium_grant.logical__1_target')}} <br/>
                            <span class="font-weight-normal">{{$t('medium_grant.logical__1_reference_year')}}</span>
                        </th>
                        <th class="align-baseline" width="21%">
                            {{$t('medium_grant.logical__1_source_verification')}} <br/>
                            <span class="font-italic font-weight-normal">{{$t('medium_grant.logical__1_source_verification_ecpcm')}}</span>
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in MonitoringForm.model.original_logframe.timeline_results" :key="'result_'+index">
                            <td>
                                <h4><strong>{{$t('medium_grant.technical__8_timeline_result') + ' ' + (index + 1)}}.</strong></h4>
                            </td>
                            <td>
                                <textarea
                                    class="form-control"
                                    :placeholder="$t('medium_grant.general__write_here')"
                                    v-model="item.indicator"
                                    >
                                </textarea>
                            </td>
                            <td>
                                <textarea
                                    class="form-control"
                                    :placeholder="$t('medium_grant.general__write_here')"
                                    v-model="item.baseline"
                                    >
                                </textarea>
                            </td>
                            <td>
                                <textarea
                                    class="form-control"
                                    :placeholder="$t('medium_grant.general__write_here')"
                                    v-model="item.target"
                                    >
                                </textarea>
                            </td>
                            <td>
                                <textarea
                                    class="form-control"
                                    :placeholder="$t('medium_grant.general__write_here')"
                                    v-model="item.source"
                                    >
                                </textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table class="mt-5 table-bordered" width="100%">
                    <thead class="text-center">
                        <th class="align-baseline" width="25%">
                            {{$t('medium_grant.logical__1_activities')}} <br/> {{$t('medium_grant.logical__1_activities_actions')}}
                            <br/> <span class="font-italic font-weight-normal">{{$t('medium_grant.logical__1_ecpcm_guidelines')}}</span>
                            <br/>
                            <a class="text-body" href="https://ec.europa.eu/europeaid/sites/devco/files/methodology-aid-delivery-methods-project-cycle-management-200403_en_2.pdf" target="_blank">https://ec.europa.eu/europeaid/sites/devco/files/methodology-aid-delivery-methods-project-cycle-management-200403_en_2.pdf</a>
                        </th>
                        <th class="align-middle" width="50%">
                            {{$t('medium_grant.logical__1_activities_deliverable')}} <br/>
                        </th>
                        <th class="align-baseline" width="25%">
                            {{$t('medium_grant.logical__1_source_verification')}} <br/>
                            <span class="font-italic font-weight-normal">{{$t('medium_grant.logical__1_source_verification_ecpcm')}}</span>
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in MonitoringForm.model.original_logframe.timeline_results" :key="'result2_'+index">
                            <td>
                                <h4><strong>{{$t('medium_grant.technical__8_timeline_result') + ' ' + (index +1)}}</strong></h4>
                                <div v-for="(activity, activityIndex) in item.activities" :key="'activity_'+activityIndex">
                                    <h5>
                                        <strong>{{$t('medium_grant.technical__8_timeline_activity') + ' ' + (index +1)}}.{{activityIndex+1}}:</strong>
                                        <span class="ml-3">{{activity.name}}</span>
                                    </h5>
                                </div>
                            </td>
                            <td>
                                <textarea
                                    class="form-control"
                                    :placeholder="$t('medium_grant.general__write_here')"
                                    v-model="item.deliverable"
                                    >
                                </textarea>
                            </td>
                            <td>
                                <textarea
                                    class="form-control"
                                    :placeholder="$t('medium_grant.general__write_here')"
                                    v-model="item.source2"
                                    >
                                </textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <p class="mt-5">
                    {{$t('medium_grant.logical__1_info_simplified')}}
                    <a class="text-body" target="_blank" href="http://ec.europa.eu/europeaid/sites/devco/files/methodology-aid-delivery-methods-project-cycle-management-200403_en_2.pdf">http://ec.europa.eu/europeaid/sites/devco/files/methodology-aid-delivery-methods-project-cycle-management-200403_en_2.pdf</a>
                </p>
            </div>
        </div>
    </form>
</template>
<script>
    import {MonitoringForm} from '@/services';

    export default
    {
        components:
        {
            MonitoringForm,
        },
        data()
        {
            return {
                MonitoringForm,
            }
        },
        computed:
        {

        },
        mounted()
        {
            setTimeout(function ()
            {
                $('td textarea').each(function () {
                    $(this).css('min-height', $(this).closest('td').height())
                })
            }, 200);
        },
        methods:
        {
            getError(field)
            {
                return this.errors.first(field);
            },
            validate()
            {
                return this.$validator.validateAll().then(res =>
                {
                    this.$emit('on-validated', res, this.model);

                    return res;
                });
            },
        },
    };
</script>
